import {
	BasePolyNodeSaveController,
	PolyNodeCRUDServerResponse,
} from '../../polygonjs-editor/src/editor/core/_BasePolyNodeSaveController';
import {Csrf} from '../../polygonjs-editor/src/editor/core/Csrf';
import {StoreController} from '../../polygonjs-editor/src/editor/store/controllers/StoreController';
import {NodeContext} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {BaseNodeType} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/nodes/_Base';
import {PolyNodeController} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeController';
import {PolyNodeDataRegister} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeDataRegister';

export class WebEditorPolyNodeSaveController extends BasePolyNodeSaveController {
	readAndRegisterPolyNodes() {
		const poly_node_elements = document.querySelectorAll('[data-poly-node]');
		for (let i = 0; i < poly_node_elements.length; i++) {
			const element = poly_node_elements[i] as HTMLElement;
			const nodeType = element.dataset['nodeType'];
			const nodeContext = element.dataset['nodeContext'];
			const dataStr = element.dataset['nodeData'];
			if (nodeType && nodeContext && dataStr) {
				try {
					const data = JSON.parse(dataStr);
					PolyNodeController.createNodeClassAndRegister({
						type: nodeType,
						context: nodeContext as NodeContext,
						data,
					});
				} catch (e) {
					console.warn(`could not load poly node ${nodeContext}/${nodeType}`);
				}
			} else {
				console.log(`found invalid polynode element`, element, {nodeType, nodeContext, dataStr});
			}
		}
	}

	async create(
		node: BaseNodeType,
		polyNodeData: PolyNodeDataRegister<NodeContext>
	): Promise<BaseNodeType | undefined> {
		const {context, type, data} = polyNodeData;
		const username = StoreController.editor.currentUser.username();

		const url = `/api/poly_nodes/${username}/${context}/${type}`;
		const response = await fetch(url, {
			body: JSON.stringify(data),
			method: 'POST',
			headers: Csrf.headers(),
		});
		const json = (await response.json()) as PolyNodeCRUDServerResponse;
		if (json.error) {
			StoreController.editor.status.setError(json.error);
		} else {
			const newNode = this._createPolyNodeAndReplaceNode(node, polyNodeData);
			StoreController.editor.status.setMessage('poly node created');
			if (newNode) {
				return newNode;
			}
		}
	}

	async update(
		node: BaseNodeType,
		polyNodeData: PolyNodeDataRegister<NodeContext>
	): Promise<BaseNodeType | undefined> {
		const {context, type, data} = polyNodeData;
		const username = StoreController.editor.currentUser.username();

		const url = `/api/poly_nodes/${username}/${context}/${type}`;
		const response = await fetch(url, {
			body: JSON.stringify(data),
			method: 'PATCH',
			headers: Csrf.headers(),
		});
		const json = (await response.json()) as PolyNodeCRUDServerResponse;
		if (json.error) {
			StoreController.editor.status.setError(json.error);
		} else {
			const newNode = this._updatePolyNodeAndReplaceNodes(node, polyNodeData);
			StoreController.editor.status.setMessage('poly node updated');
			if (newNode) {
				return newNode;
			}
		}
	}
}
